<template>
	<div>
		<h2 class="primary--text cn-font">
			{{title}}
		</h2>
		<p>{{text}}</p>
		<v-list color="transparent">
			<v-list-item v-for="(point, i) in points" :key="i">
				<v-list-item-icon>
					<v-avatar color="accent" dark icon><v-icon color="white">{{point.icon}}</v-icon></v-avatar>
				</v-list-item-icon>
				<v-list-item-content>
					{{point.text}}
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "IconPoints", 
		props: {
			points: {type: Array}, 
			title:  {type: String },
			text:  {type: String },
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"